import React from "react";

const Logo = ({ src, alt = "Logo", className = "w-20 h-auto" }) => {
  return (
    <img
      src={src}
      alt={alt}
      loading="eager"
      className={className}
    />
  );
};

export default Logo;
